import {
    OnBoardingImagesDto,
    SoftwarePackageDto,
    SoftwarePackagesData,
    SoftwarePackagesDataDto,
} from "domain/softwarePackages";
import { apiGatewayService } from "services/api/ApiGatewayService";
import { getObject, RepositoryKey } from "utils/repository";

/**
 * Handles interactions with get software packages list API.
 */

export function toSoftwarePackagesData(dto: SoftwarePackagesDataDto): SoftwarePackagesData {
    const softwarePackagesData: SoftwarePackagesData = {
        productDownloads: [],
        onboardingImages: [],
    };

    dto.productDownloads.map((each: SoftwarePackageDto) => {
        softwarePackagesData.productDownloads.push({
            productName: each.productName,
            licenseIds: each.licenseIds.map(String),
            versions: each.versions,
            bmpHomeGroup: each.bmpHomeGroup,
            bmpHomeCategory: each.bmpHomeCategory,
            bmpHomeUseCases: each.bmpHomeUseCases,
            bpmHomeTargets: each.bpmHomeTargets,
            bmpHomeOperatingSystems: each.bmpHomeOperatingSystems,
            bmpHomeProcessors: each.bmpHomeProcessors,
        });
    });
    dto.onboardingImages?.map((each: OnBoardingImagesDto) => {
        softwarePackagesData.onboardingImages.push({
            licenseId: each.licenseId,
            manual: each.manual,
            workflow: each.workflow,
            shaForManual: each.shaForManual,
            manualProductName: each.manualProductName,
            shaForWorkflow: each.shaForWorkflow,
        });
    });
    return softwarePackagesData;
}

class SoftwarePackagesService {
    public async fetchSoftwarePackages(): Promise<SoftwarePackagesData> {
        const supportSoftwareUrl = "https://api.blancco.com/support/software";
        return apiGatewayService
            .fetch(getObject(RepositoryKey.SUPPORT_SOFTWARE_URL) || supportSoftwareUrl)
            .then((res) => res.json())
            .then((res: SoftwarePackagesDataDto) => toSoftwarePackagesData(res));
    }
}

export const softwarePackagesService = new SoftwarePackagesService();
